import DynamicTable from "../../../components/tables/dynamicTable";
import Sidebar from "../../../components/sidebar/Sidebar";
import NavBar from "../../../components/navbar/NavBar";
import { config } from "../../../config/Constants";
import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import Axios from "axios";

//get exception report data main function
const ExceptionReport = () => {
  const [loading, setLoading] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  useEffect(() => {
    getExceptionData();
  }, []);

  // Get the data for the report and set
  const getExceptionData = async () => {
    const response = await Axios.get(config.url.GET_REPORT, {
      params: {
        reportName: "purecareexceptionreport",
        companyName: Cookies.get("cp-cn"),
      },
    });
    const rawData = formatData(response.data.report);

    const enhancedData = rawData.map((item) => {
      let link = "";
      let url = ''

      if (item.CARRIER === "TForce" && item.PRO_NUMBER) {
        url = `https://www.tforcefreight.com/ltl/apps/Tracking?proNumbers=${item.PRO_NUMBER}`;
      } else if (item.CARRIER === "CROSSCOUNTRY FREIGHT SOLUTIONS" && item.PRO_NUMBER) {
        url = `https://auth.ccfs.com/track/detail/${item.PRO_NUMBER}`;
      }
      else if (item.CARRIER === "SAIA LTL FREIGHT" && item.PRO_NUMBER) {
        url = `https://www.saia.com/track/details;pro=${item.PRO_NUMBER}`;
      }
      else if (item.CARRIER === "OAK HARBOR FREIGHT LINES" && item.PRO_NUMBER) {
        url = `https://www.oakh.com/page/tracing`;
      }
      else if (item.CARRIER === "ABF FREIGHT SYSTEM" && item.PRO_NUMBER) {
        url = `https://arcb.com/tools/tracking.html#/${item.PRO_NUMBER}`;
      }
      else if ((item.CARRIER === "FEDEX FREIGHT - ECONOMY" || item.CARRIER === 'FEDEX FREIGHT - PRIORITY') && item.PRO_NUMBER) {
        url = `https://www.fedex.com/fedextrack/?trknbr=${item.PRO_NUMBER}`;
      }
      else if (item.CARRIER === "UPS" && item.PRO_NUMBER) {
        url = `https://www.ups.com/track?track=yes&trackNums=${item.PRO_NUMBER}&loc=en_US&requester=ST/trackdetails`;
      }
      else url = 'none'
      link = <a href={url} target="_blank" rel="noopener noreferrer">Track Shipment</a>;
      if (url === 'none'){link = null} 
      return {...item, 'Tracking': link || "N/A"};
    });
    setLoading(false);
    setFilteredData(enhancedData);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date
      .toLocaleDateString("en-US", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
      })
      .trim();
  };
 const formatData = (data) => {
  return data.map((item) => {
    const updatedItem = {
      ...item,
      PICKUP_DATE: item["PICKUP_DATE"]
        ? formatDate(item["PICKUP_DATE"])
        : "N/A",
      EXCEPTED_DELIVERY_DATE: item["EXCEPTED_DELIVERY_DATE"]
        ? formatDate(item["EXCEPTED_DELIVERY_DATE"])
        : "N/A",
      EXCEPTION_DATE: item["EXCEPTION_DATE"]
        ? formatDate(item["EXCEPTION_DATE"])
        : "N/A",
    };

    if (item["NEW_EXPECTED_DELIVERY_DATE"]) {
      const newDate = new Date(item["NEW_EXPECTED_DELIVERY_DATE"]);
      newDate.setDate(newDate.getDate() + 1);
      updatedItem["NEW_EXPECTED_DELIVERY_DATE"] = formatDate(
        newDate.toISOString()
      );
    } else {
      updatedItem["NEW_EXPECTED_DELIVERY_DATE"] = "Not Returned in the API";
    }

    return updatedItem;
  });
};


  return (
    <div className="serviceStatsPage">
      <div className="LandingPageContainer">
        <NavBar />
        <Sidebar />
        <div className="tableReportsPageContent">
          <div className="scoreBoardTitle">
            <h1>Exception Report</h1>
            </div>
            <div>
            <i style={{ "margin-top": "-5px" }}>
              * Report contains only undelivered loads and their exceptions.
            </i>
          </div>
          <div className="reportSpace">
            {loading ? (
              <p>Loading...</p>
            ) : (
              <div className="report" style={{ "margin-top": "5px" }}>
                <DynamicTable dataObject={{ data: filteredData, size: "small" }} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExceptionReport;
